import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useBackofficeLaunchCampaignMutation } from "modules/campaigns/hooks/useBackofficeLaunchCampaignMutation"
import CustomersFormSelector from "modules/customers/components/Form/CustomersFormSelector"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Route as CampaignIdRoute } from "routes/_base/_auth/campaigns/$id/route"
import { CampaignDetailResponseDataSchema } from "schema"
import { z } from "zod"

type Props = {
  campaign: z.infer<typeof CampaignDetailResponseDataSchema>
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const BackofficeLaunchCampaign = ({ campaign, open, onOpenChange }: Props) => {
  const { t } = useTranslation()
  const { id } = CampaignIdRoute.useParams()
  const { mutateAsync } = useBackofficeLaunchCampaignMutation(id)
  const [customerId, setCustomerId] = useState<string | null>(null)

  const onConfirm = () => {
    if (customerId) {
      mutateAsync(customerId).then(() => onOpenChange(false))
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("campaigns.detail.backofficeLaunchCampaign.warningTitle")}</DialogTitle>
          <DialogDescription>
            {t("campaigns.detail.backofficeLaunchCampaign.warningDescription")}
          </DialogDescription>
        </DialogHeader>
        <div>
          <CustomersFormSelector
            emptyPlaceholder={t("campaigns.detail.backofficeLaunchCampaign.emptyPlaceholder")}
            onChange={(customer) => customer?.value && setCustomerId(customer?.value)}
            placeholder={t("campaigns.detail.backofficeLaunchCampaign.placeholder")}
            searchPlaceholder={t("campaigns.detail.backofficeLaunchCampaign.searchPlaceholder")}
            displayPhone={campaign.channel === "Whatsapp"}
          />
        </div>
        <DialogFooter>
          <Button variant={"secondary"} onClick={() => onOpenChange(false)}>
            {t("campaigns.detail.backofficeLaunchCampaign.cancel")}
          </Button>
          <Button variant={"destructive"} onClick={onConfirm} disabled={!customerId}>
            {t("campaigns.detail.backofficeLaunchCampaign.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
